import ProviderCard from './ProviderCard';

export default ProviderCard;
